import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsCoreNotificationsIssueLogsRoute: InvariantJiraRoute = {
	name: 'project-settings-core-notifications-issue-logs',
	path: '/jira/core/projects/:projectKey/settings/notifications/issue-logs',
	exact: true,
};
